import React from "react";

export default function BtnLimpiarSeleccion({
  filters,
  onClick,
  disabled = false,
  className = "btn-fil",
  label = "Limpiar Selección",
}) {
  if (!filters) return null;

  const hasActiveFilters = Object.values(filters).some((v) =>
    Array.isArray(v) ? v.length > 0 : (v ?? "") !== "",
  );

  if (!hasActiveFilters) return null;

  return (
    <button
      type="button"
      className={className}
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </button>
  );
}
